<template>
  <main class="container-xl login-area mt-5">
    <div class="primary-area">
      <section>
        <form @submit.prevent="validate" novalidate>
          <div class="contents">
            <div class="login-input">
              <dl class="section-item">
                <dt>
                  <h3>ログイン</h3>
                </dt>
                <dt>メールアドレス</dt>
                <dd>
                  <Input
                    required
                    :class="{
                      'form-error': this.formErrors.signIn.getErrorMsg('email'),
                    }"
                    type="email"
                    v-model="formItems.email" />
                  <div class="small notes notes-error">
                    {{  this.formErrors.signIn.getErrorMsg('email') }}
                  </div>
                </dd>
                <dt>パスワード</dt>
                <dd>
                  <Input
                    :class="{
                      'form-error': this.formErrors.signIn.getErrorMsg('password'),
                    }"
                    required
                    type="password"
                    v-model="formItems.password"
                  />
                  <div class="small notes notes-error">
                    {{  this.formErrors.signIn.getErrorMsg('password') }}
                  </div>
                </dd>
              </dl>
              <Link class="small" @click="resetPassword">パスワードをお忘れですか？</Link>
            </div>
            <Button
                :disabled="!isScreenActive"
            >ログイン
            </Button>
          </div>
        </form>
      </section>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Button, Input, Link } from "components";

import { signIn } from "utils/auth";
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

import {
  SignInValidator,
} from "validators/sing-in";

export default {
  name: "Login",
  components: {
    Button,
    Input,
    Link,
  },
  data() {
    return {
      formItems: {
        email: "",
        password: "",
      },
      formErrors: {
        signIn: new SignInValidator(),
      },
      screenStatus: {
        submitBtn: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
    }),
    ...mapGetters({
      signUpNotificationFlag: "application/signUpNotificationFlag",
      resetPasswordNotificationFlag: "application/resetPasswordNotificationFlag",
    }),
  },
  async created() {
    this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    if (this.signUpNotificationFlag === true) {
      this.setNotification({
        message: "アカウント作成しました。",
      });
      this.updateSignUpNotificationFlag(false);
    }
    if (this.resetPasswordNotificationFlag === true) {
      this.setNotification({
        message: "パスワードをリセットしました。",
      });
      this.updateResetPasswordNotificationFlag(false);
    }
  },
  methods: {
    ...mapActions({
      // app
      updateNotificationFlags: "application/updateNotificationFlags",
      updateScreenStatusCd: "application/updateScreenStatusCd",
      // notification
      setErrorNotification: "notification/setErrorNotification",
      addErrorNotification: "notification/addErrorNotification",
      resetNotificaton: "notification/resetState",
      setNotification: "notification/setNotification",
      updateSignUpNotificationFlag: "application/updateSignUpNotificationFlag",
      updateResetPasswordNotificationFlag: "application/updateResetPasswordNotificationFlag",
    }),
    async validate() {
      try {
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        this.resetNotificaton();

        // 入力バリデーション　→ (Bootstrapのjsによる制御のため強制でTrue)
        this.formErrors.signIn = SignInValidator.validate(
          this.formItems.email,
          this.formItems.password,
        );

        if (!this.formErrors.signIn.result) {
          this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          this.submit();
        }
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    async submit() {
      try {
        // 成功時の処理
        const authData = await signIn(this.formItems.email, this.formItems.password);
        if (authData) {
          this.updateNotificationFlags(true);
          this.$router.push({
            name: "MonitoringTargetsList",
          });
        } else {
          this.setErrorNotification({
            message: "入力に誤りがあります。",
          });
          this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        }
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
        if (err.name === "NotAuthorizedException") {
          this.setErrorNotification({
            message: "入力に誤りがあります。",
          });
        } else {
          this.setErrorNotification({
            message: "予期せぬエラーが発生しました。",
          });
        }
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    resetPassword() {
      this.$router.push({
        name: "ResetPasswordSendAuthCode",
      });
    },
  },
};
</script>
